/**
 *  27/03/2019 v 1.0 - JuanMa
 *  v 1.1 01/04/2019 Corrección de !=
 *  v 1.2 07/05/2019 Cambiado onLoad de DidMount a evento OnMostrar, para que sólo se cargue al mostrar la lista
 *  v 1.3 09/05/2019 Añadida prop valorTextoInicial para poner un texto en el input antes de cargar la lista desde la bdd
 *  v 1.4 23/05/2019 Añadido soporte de condiciones en la carga de elementos
 *  v 1.5 27/05/2019 Añadido spinner de carga y propiedad cargandoDatos para controlarlo
 *                   Añadida propiedad noMostrarCero
 *  v 1.6 30/09/2019 Modificado para usar el nombre del paquete dinámicamente en la deteccion de clases.
 *                   Añadido icon a State para transmitirlo al renderizar SelectorLista
 *                   Añadido ordenInicial a props para especificar el orden
 *                   Añadido orden al generar el filtro de load()
 *  v 1.7 23/10/2019 Añadida propiedad tabOrderManager
 *                   Añadida propiedad CampoNombre necesaria para la gestión de tabOrderManager
 *  v 1.8 24/10/2019 Cambiadas propiedades filtroNombreCampo y filtroTituloCampo por gridColumnaCampo y gridColumnaTitulo
 *  v 1.9 04/11/2019 Asignación de la propiedad datoSelected de SelectorLista con elementoSeleccionado
 *  v.2.0 30/09/2020 Cambiado a framework2
 *  v.2.1 13/07/2021 Anulado this.asignarElementoSeleccionado(); en CompnentDidMount porque generaba recursion
 *  v.2.2 17/10/2023 Añadida la propiedad clickRowEsAceptar={true} a la llamada <SelectorLista
**/

import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import ClienteRestful from "../network/ClienteRestful";
import SelectorLista from "./SelectorLista";
import {filtrarConNombreCampo} from "../utils/FilterUtils"
import {getFiltroFromCampo, getFiltroInicialFromCampoFECHAPERIODO} from "../utils/FiltroGridUtils";
import { FILTRO_MAYOR } from './FormularioGridBusqueda'
import {nombrePaquete} from "../../../dental/Configuracion";
import {cacheClaseChanged} from "../../../dental/redux/cache/actions";
import connect from "react-redux/es/connect/connect";



class SelectorListaClase extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            titulo: props.titulo,
            campoValor: props.campoValor,
            campoMostrar: props.campoMostrar,
            valor: props.valor,
            valorTextoInicial: props.valorTextoInicial,
            icon: props.icon,
            elementos: [], //[{}],
            elementoSeleccionado: props.valor,
            cargandoDatos: false,
            noMostrarCero: props.noMostrarCero,
            claseSimple: this.calcularClaseSimple(props.clase),
            usarCache: props.usarCache ? props.usarCache : false,

        }
    }

    calcularClaseSimple= (clase) => {
        let pos= nombrePaquete.length;
        let claseSimple= clase.substr(pos);
        return claseSimple;
    }

    componentDidUpdate(prevProps, prevState) {
        //this.asignarElementoSeleccionado();
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.valor !== prevState.valor) {
            newState.valor = nextProps.valor;
        }
        if (nextProps.valorTextoInicial !== prevState.valorTextoInicial) {
            newState.valorTextoInicial = nextProps.valorTextoInicial;
        }
        if (nextProps.camposValor !== prevState.camposValor) {
            newState.camposValor = nextProps.camposValor;
        }
        if (nextProps.campoMostrar !== prevState.campoMostrar) {
            newState.campoMostrar = nextProps.campoMostrar;
        }
        if (nextProps.usarCache !== prevState.usarCache) {
            newState.usarCache = nextProps.usarCache;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    load= () => {
        const {usarCache} = this.state;
        if (usarCache){
            //Comprobamos si está cacheado:
            const {claseSimple} = this.state;
            const {cache} = this.props; //Cache viene del Redux
            let datosCacheados= cache.clases[claseSimple];
            if (datosCacheados){
                this.setState({cargandoDatos: false, elementos: datosCacheados}, () => {
                    this.asignarElementoSeleccionado();
                });
            }
            else{
                this.loadDeServidor();
            }
        }
        else{
            this.loadDeServidor();
        }
    }
    loadDeServidor = () => {
        const {claseSimple, noMostrarCero, usarCache} = this.state;
        const {urlServicioRestful, condiciones, ordenInicial} = this.props;
        const url= urlServicioRestful + "list/" + claseSimple;
        //console.log(url);
        const clienteRestful = new ClienteRestful().setUrl(url);


        var filtro= {condiciones: [], orden: []};
        condiciones && condiciones.forEach ( (campo) => {
            if (campo.valor)  {
                let filtroCampo = getFiltroFromCampo(campo, campo.valor, campo.valor2);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }

            if (campo.tipoValor){
                let filtroCampo=  getFiltroInicialFromCampoFECHAPERIODO(campo);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }
        });

        //Añadimos condicion de cero inmutable
        if (noMostrarCero){
            filtro.condiciones.push(
                {nombreCampo: "codigo", tipo: FILTRO_MAYOR,  valor: 0}
            );
        }

        //Añadimos el ordenInicial:
        ordenInicial && ordenInicial.forEach ( (orden) => {
            filtro.orden.push({nombreCampo: orden.nombreCampo, asc: orden.asc});
        });


        console.log("SelectorListaClase");
        console.log(filtro);
        clienteRestful.doPost( filtro, response => {
            if (clienteRestful.exito && response){
                let newElementos= response.lo;
                this.setState({cargandoDatos: false, elementos: newElementos}, () => {
                    this.asignarElementoSeleccionado();
                    if (usarCache)
                        this.props.dispatch(cacheClaseChanged(claseSimple, newElementos));
                });

            }
        });
    }

    asignarElementoSeleccionado= () => {
        const {valor, elementos, campoValor} = this.state;

        if (elementos && elementos.length > 0){
            let coincidentes= filtrarConNombreCampo(elementos, campoValor, valor);
            if (coincidentes && coincidentes.length > 0){
                this.setState({elementoSeleccionado: coincidentes[0]});
            }

        }
    }

    onElementoChanged= (elemento) => {
        const {onElementoChanged} = this.props;
        this.setState({elementoSeleccionado: elemento}, () => {
            onElementoChanged && onElementoChanged(elemento);
        })
    }

    onListaMostrar= () => {
        const {elementos} = this.state;
        if (!elementos || elementos.length === 0){
            this.setState({cargandoDatos: true}, () => {this.load()})
        }
    }

    render() {
        const {titulo, icon, elementos, elementoSeleccionado, campoMostrar,  valorTextoInicial, cargandoDatos,} =  this.state;
        const {tabOrderManager, campoNombre} = this.props;

        return (
            <SelectorLista id= {titulo}
                           datos={elementos}
                           valor={elementoSeleccionado ? elementoSeleccionado[campoMostrar] : valorTextoInicial }
                           titulo={titulo}
                           icon={icon}
                           gridColumnaCampo={campoMostrar} gridColumnaTitulo={titulo}
                           OnDatoChanged={ this.onElementoChanged}
                           onMostrar={this.onListaMostrar}
                           cargandoDatos={cargandoDatos}
                           tabOrderManager={tabOrderManager}
                           campoNombre={campoNombre}
                           datoSelected={elementoSeleccionado}
                           clickRowEsAceptar={true}
            />
        );
    }
}


SelectorListaClase.propTypes = {
    clase: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    campoValor: PropTypes.string.isRequired,
    campoMostrar: PropTypes.string.isRequired,
    valor: PropTypes.number,
    valorTextoInicial: PropTypes.string,
    icon: PropTypes.string,
    urlServicioRestful: PropTypes.string.isRequired,
    condiciones: PropTypes.array,
    ordenInicial: PropTypes.array,
    tabOrderManager: PropTypes.object,
    campoNombre: PropTypes.string,
    usarCache: PropTypes.bool,
}

const mapStateToProps = function(state) {
    return {
        cache: state.cache,
    }
}

export default connect(mapStateToProps)(SelectorListaClase);
